export default __webpack_public_path__ + "static/media/correct.ff2b3b6a.svg";